<template>
    <router-link :to="{ name: 'login' }"
                 class="btn  btn--white-bg nav__button nav__button--content header__button"
    >
        <svg width="23" height="23">
            <use xlink:href="/assets/front/img/sprite.svg#icon-user"></use>
        </svg>
    </router-link>
</template>

<script>
export default {
    name: 'HeaderLoginButton'
}
</script>
